import styled from 'styled-components'
import { HomePageLink } from '../HomePageLink/HomePageLink'
import { ResponsivePicture } from '../ResponsivePicture/ResponsivePicture'

export const Background = styled.div`
  background-color: ${({ theme }) => theme.colors.background};
`

export const Frame = styled.section`
  position: relative;
  min-height: 56rem;
  display: flex;
  justify-content: center;
  align-items: center;

  @media screen and (min-width: 768px) {
    min-height: 70rem;
  }
`

export const ImageWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`

export const Image = styled(ResponsivePicture)`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

export const Description = styled(HomePageLink)`
  text-align: center;
  max-width: 50rem;
  background: ${({ theme }) => theme.colors.background};
  position: relative;
  z-index: 1;
  padding: 3rem 16%;
  margin: 10rem 6rem;

  @media screen and (min-width: 768px) {
    padding: 3.8rem 8.4rem;
  }
`
